export const navbarLinks = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/services", label: "Services" },
  { to: "/products", label: "Products" },
  { to: "/research-development", label: "R&D" },
  { to: "/quality-assurance", label: "Quality" },
  { to: "/contact", label: "Contact" },
]

